/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { reposList } from "../../funcs/reposList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListReposRequest$inboundSchema,
};

export const tool$reposList: ToolDefinition<typeof args> = {
  name: "repos-list",
  description: `List the caller's org's repositories

Returns every repository in the caller's org (org owner/admin only).
Pure DB read.
`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await reposList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
